import { Injectable } from '@angular/core';
import { AccountStore } from './account.store';
import { map, tap } from 'rxjs/operators';
import { ApiService } from '@core/services/api/api.service';
import { Observable } from 'rxjs';
import { Account } from '@core/models/account.model';

@Injectable({providedIn: 'root'})
export class AccountService {

  constructor(private accountsStore: AccountStore,
              private api: ApiService) {
  }

  get(): Observable<Account> {
    return this.api.get('people/self')
      .pipe(
        tap(entities => this.accountsStore.update(entities.data)),
        map(data => data.data),
      );
  }

  getCached() {
    return this.accountsStore.getValue();
  }
}
